import {
  Breakpoints,
  colors,
  getBorderRadius,
  getHeight,
  getSpacing,
  getWidth,
} from '@cabonline/ui-shared';
import styled from '@emotion/styled';

type Device = 'mobile' | 'tablet' | 'desktop';

export interface ContainerProps {
  $width?: {
    mobile?: string;
    tablet?: string;
    desktop?: string;
  };
  isSecondaryModal?: boolean;
}

const defaultWidth: Record<Device, string> = {
  tablet: '90%',
  mobile: `calc(100% - ${getSpacing('xl')})`,
  desktop: '80%',
};

const getContainerWidth = (
  width: ContainerProps['$width'],
  device: Device,
  isSecondaryModal?: boolean
) => {
  const horizontalPadding = isSecondaryModal ? getSpacing('xl', 2) : '0px';
  const containerWidth = width?.[device] || defaultWidth[device];
  return `calc(${containerWidth} - ${horizontalPadding})`;
};

export const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledCloseButtonWrap = styled.div`
  margin-left: auto;
`;

export const StyledOverlay = styled.div<{ isSecondaryModal: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: ${(p) => (p.isSecondaryModal ? 1002 : 1000)};
`;

export const StyledModalContainer = styled.div<ContainerProps>`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: ${(p) => (p.isSecondaryModal ? 1003 : 1001)};
  background-color: ${colors.white};
  border-radius: ${getBorderRadius('l')};
  padding: ${getSpacing('m')};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  max-height: calc(100% - ${getHeight('m')});
  max-width: ${(p) => (p.$width ? p.$width : getWidth('modal'))};
  overflow-y: auto;
  box-shadow: ${(p) =>
    p.isSecondaryModal &&
    '0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22)'};

  @media (max-width: ${Breakpoints.Tablet}px) {
    width: ${(props) =>
      getContainerWidth(props?.$width, 'tablet', props.isSecondaryModal)};
    max-height: 90%;
  }

  @media (max-width: ${Breakpoints.Mobile}px) {
    width: ${(props) =>
      getContainerWidth(props?.$width, 'mobile', props.isSecondaryModal)};
    max-height: 90%;
  }

  @media (min-width: ${Breakpoints.Tablet}px) {
    width: ${(props) =>
      getContainerWidth(props?.$width, 'desktop', props.isSecondaryModal)};
  }
`;
